import {
  ActionType,
  ISubscribeSuperCityResponse,
  ISubscribeSuperCityPayload,
} from "models/patients/subscribeSuperCity";

export const subcribeAction = (payload: ISubscribeSuperCityPayload) => {
  return {
    type: ActionType.SUBSCRIBE_SUPER_CITY,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.SUBSCRIBE_SUPER_CITY_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: ISubscribeSuperCityResponse) => {
  return {
    type: ActionType.SUBSCRIBE_SUPER_CITY_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.SUBSCRIBE_SUPER_CITY_RESET,
  };
};
